import React from "react";
import { mapIotPartnerToDataTable as mapData } from "./Helper";
import GetIotPartnerColumns from "./ColumnDefinition/IotPartnerColumn/GetIotPartnerColumns";
import ReusableDndTable from "src/components/table/ReusableDndTable/ReusableDndTable";

const IotPartnerTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  onDragEnd,
  status,
}) => {
  const columns = GetIotPartnerColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDndTable
      columns={columns}
      data={mapData(data)}
      maxHeight={500}
      onDragEnd={onDragEnd}
    />
  );
};

export default IotPartnerTable;
